import BB from 'backbone';
import MobileDetect from 'mobile-detect';
import Storage from './Storage';
import Preloader from './Preloader';
import LodashMixines from './LodashMixines';
import SaveMultipartFormData from './SaveMultipartFormData';
import ErrorsModal from './ErrorsModal';
import TippingErrorsModal from './TippingErrorsModal';
import FileUtility from './File';
import Modal from './Modal';
import Secret from './SecretKey';
import sendDataLayer from './sendDataLayer';
import Cookie from "./Storage/Cookie";

/**
 * Check for user session
 * @return {boolean}
 */
const isAuthorized = () => Boolean(Storage.get('sid')) || Boolean(Cookie.get('session'));
const hasSid = () => Boolean(Storage.get('sid'));


/**
 * Redirect to
 * @param {string} path - navigate hash string
 * @param {object} opts - history.navigate args. By default {trigger: true}
 */
const redirectTo = (path = '/', opts = { trigger: true }) => {
	return BB.history.navigate(path, opts);
};
const rerender = () => {
	BB.history.loadUrl();
}
const jumpToAnchor = href => {
	if (!href) {
		return false;
	}

	setTimeout(function () {
		location.href = `#${href.split('#')[1]}`;
	}, 1);
};

export { Preloader };
export { isAuthorized };
export { hasSid };
export { redirectTo };
export { LodashMixines };
export { SaveMultipartFormData };
export { ErrorsModal };
export { TippingErrorsModal }
export { FileUtility };
export { Modal };
export { Storage };
export { sendDataLayer };
export { Secret };
export { jumpToAnchor };

export default {
	isAuthorized,
	hasSid,
	redirectTo,
	Preloader,
	LodashMixines,
	SaveMultipartFormData,
	ErrorsModal,
	TippingErrorsModal,
	FileUtility,
	Modal,
	Storage,
	sendDataLayer,
	Secret,
	jumpToAnchor,
	rerender
}

export const isMobileView = () => {
	if ('matchMedia' in window) {
		return window.matchMedia("(max-width: 999px)").matches;
	}

	return false;
};

export const isMobile = () => {
	const MobileDetector = new MobileDetect(window.navigator.userAgent);
	return Boolean(MobileDetector.mobile());
};

export const isTablet = () => {
	const MobileDetector = new MobileDetect(window.navigator.userAgent);
	return Boolean(MobileDetector.tablet());
};

export const fbInit = () => {
	const fb_id = process.env.FB_ID;//641702585894218;

	window.fbAsyncInit = function () {
		FB.init({
			appId: fb_id,
			autoLogAppEvents: true,
			xfbml: true,
			version: 'v3.1'
		});
	};

	(function (d, s, id) {
		let js, fjs = d.getElementsByTagName(s)[0];
		if (d.getElementById(id)) {
			return;
		}
		js = d.createElement(s);
		js.id = id;
		js.src = "https://connect.facebook.net/en_US/sdk.js";
		fjs.parentNode.insertBefore(js, fjs);
	}(document, 'script', 'facebook-jssdk'));
};

export const getSponsorLogo = () => null;

export const isFloat = n => {
	return n !== "" && !isNaN(n) && Math.round(n) !== n;
};

export const sizes_for_big_ad = () => {
	if (isTablet()) {
		return [728, 90];
	}
	return isMobileView() ? [300, 250] : [970, 250];
};